







    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "NotFoundBanner",
        components: {},
        mixins:[]
    })
    export default class NotFoundBanner extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
